import { call, put, takeLatest, fork, all, delay, } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as HotelService from './../services/hotelService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import history from './../helpers/history';
import { PATHS, SAGA_DELAY_TIMEOUT } from '../constants/Define';
import { omit } from 'lodash';
import {
    setListHotels as setListHotelsAction,
    setHotelDetail as setHotelDetailAction,
    setAllHotels,
    setTagGroupDetailSku,
    setAllHotelActive,
    setListRateCompare
} from './../actions/hotelAction';
import { hotelAutoTranslateRequest } from 'actions/autoTranslateAction';

function* getListHotel() {
    yield takeLatest(Types.HOTEL_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const limit = action.filters.pageSize ? action.filters.pageSize : undefined;
        const offset = action.filters.pageIndex ? (action.filters.pageIndex - 1) * limit : undefined;
        const params = {
            ...omit(action.filters, ['pageIndex', 'pageSize']),
            limit, offset,
        }
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(HotelService.getHotels, params);
        yield put(setListHotelsAction(result));
    }, errorHandleHotel(Types.HOTEL_LIST_FAIL)))
}

function* getListHotelActive() {
    yield takeLatest(Types.HOTEL_ALL_ACTIVE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HotelService.getAllHotelsActive, action.params);
        yield put(setAllHotelActive(result.data));
    }, errorHandleHotel(Types.HOTEL_ALL_ACTIVE_FAIL)))
}

function* getHotelDetail() {
    yield takeLatest(Types.HOTEL_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HotelService.getHotelDetail, action.id);
        yield put(setHotelDetailAction(result));
    }, errorHandleHotel(Types.HOTEL_DETAIL_FAIL)))
}

function* updateHotelDetail() {
    yield takeLatest(Types.HOTEL_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HotelService.updateHotelDetail, action.hotel);
        if (action.hotel.targetLanguage && action.hotel.targetLanguage.length > 0) {
            yield put(hotelAutoTranslateRequest({
                sourceId: action.hotel?.id,
                sourceLanguage: 'vi-VN',
                targetLanguages: action.hotel?.targetLanguage,
                callbacks: action?.callbacks
            }));
        }
        yield put(setHotelDetailAction(action.hotel));
        yield put({ type: Types.HOTEL_DETAIL_ACTION, id: action.hotel.id });
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.hotel.title')} "${action.hotel.name}"` })
    }, errorHandleHotel(Types.HOTEL_DETAIL_FAIL)))
}

function* createHotelDetail() {
    yield takeLatest(Types.HOTEL_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HotelService.createHotelDetail, action.hotel);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.hotel.title')} "${action.hotel.name}"` })
        if (action.callbacks?.onSuccess) {
            yield action.callbacks.onSuccess(result);
        }
        yield put(setHotelDetailAction(action.hotel));
    }, errorHandleHotel(Types.HOTEL_DETAIL_FAIL)))
}

// TRANSLATE
function* createHotelTranslate() {
    yield takeLatest(Types.HOTEL_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HotelService.createHotelTranslate, action.hotel);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.hotel.translate.languageName);
        yield put({ type: Types.HOTEL_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOTEL_DETAIL_ACTION, id: action.hotel.id });
    }, errorHandleHotel(Types.HOTEL_FAIL)))
}

function* updateHotelTranslate() {
    yield takeLatest(Types.HOTEL_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HotelService.updateHotelTranslate, action.hotel);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.hotel.translate.languageName);
        yield put({ type: Types.HOTEL_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOTEL_DETAIL_ACTION, id: action.hotel.id });
    }, errorHandleHotel(Types.HOTEL_FAIL)))
}

function* deleteHotelTranslate() {
    yield takeLatest(Types.HOTEL_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HotelService.deleteHotelTranslate, action.hotel.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.hotel.translate.languageName);
        yield put({ type: Types.HOTEL_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOTEL_DETAIL_ACTION, id: action.hotel.id });
    }, errorHandleHotel(Types.HOTEL_FAIL)))
}

function* getTagGroupDetailSku() {
    yield takeLatest(Types.HOTEL_TAG_GROUP_DETAIL_SKU_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HotelService.getTagroupDetailSKU, action.id);
        yield put(setTagGroupDetailSku(result));
    }, errorHandleHotel(Types.HOTEL_DETAIL_FAIL)))
}

function* updateTagroupDetailSKUActive() {
    yield takeLatest(Types.HOTEL_TAG_GROUP_DETAIL_SKU_ACTIVE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HotelService.updateTagroupDetailSKUActive, action.data);
        yield put({ type: Types.HOTEL_TAG_GROUP_DETAIL_SKU_ACTION, id: action.id });
    }, errorHandleHotel(Types.HOTEL_DETAIL_FAIL)))
}

function errorHandleHotel(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'hotel');
}

function* getAllHotel() {
    yield takeLatest(Types.HOTEL_All_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(HotelService.getAllHotels);
        yield put(setAllHotels(result));
    }, errorHandleHotel(Types.HOTEL_All_FAIL)))
}

function* clearCacheHotel() {
    yield takeLatest(Types.CLEAR_CACHE_ACTION, Func.sagaWrapper(function* (action) {
        const params = {
            type: action.value,
        }
        yield call(HotelService.clearCache, params);
        Func.sagaSuccessMessage(action, i18n.t('validation.clearCacheSuccess'));
        yield put({ type: Types.CLEAR_CACHE_SUCCESS })
    }, errorHandleHotel(Types.HOTEL_All_FAIL)))
}

function* setListRateCompareSaga() {
    yield takeLatest(Types.RATE_LIST_COMPARE_ACTION, Func.sagaWrapper(function* (action) {
        // yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(HotelService.getRateCompare, action.filters);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put(setListRateCompare(result));
    }, errorHandleHotel(Types.RATE_LIST_COMPARE_FAIL)))
}

function* createRateCompare() {
    yield takeLatest(Types.RATE_LIST_COMPARE_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(HotelService.createRateCompare, action.data);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.rateCompare.title')}` })
        history.push(PATHS.RATE_COMPATE.LIST.path.replace(':hotel_id', action.data.hotelId));
        history.go();
    }, errorHandleHotel(Types.RATE_LIST_COMPARE_FAIL)))
}

function* updateRateCompare() {
    yield takeLatest(Types.RATE_LIST_COMPARE_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(HotelService.updateRateCompare, action.data);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.rateCompare.title')}` })
        history.push(PATHS.RATE_COMPATE.LIST.path.replace(':hotel_id', action.data.dataRateCompare.hotelId));
        history.go();
    }, errorHandleHotel(Types.RATE_LIST_COMPARE_FAIL)))
}

function* deleteRateCompare() {
    yield takeLatest(Types.RATE_LIST_COMPARE_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HotelService.deleteRateCompare, action.data.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
        yield put({ type: Types.RATE_LIST_COMPARE_ACTION, filters: action.data.filters })
    }, errorHandleHotel(Types.RATE_LIST_COMPARE_FAIL)));
}

export function* hotelSaga() {
    yield all([
        fork(getAllHotel),
        fork(getListHotel),
        fork(getHotelDetail),
        fork(updateHotelDetail),
        fork(createHotelDetail),

        fork(createHotelTranslate),
        fork(updateHotelTranslate),
        fork(deleteHotelTranslate),
        fork(getTagGroupDetailSku),
        fork(updateTagroupDetailSKUActive),
        fork(getListHotelActive),

        fork(clearCacheHotel),

        fork(setListRateCompareSaga),
        fork(createRateCompare),
        fork(updateRateCompare),
        fork(deleteRateCompare),
    ])
}
